import { render, staticRenderFns } from "./wallet-management-dialog.vue?vue&type=template&id=6323cace&scoped=true&"
import script from "./wallet-management-dialog.vue?vue&type=script&lang=js&"
export * from "./wallet-management-dialog.vue?vue&type=script&lang=js&"
import style0 from "./wallet-management-dialog.vue?vue&type=style&index=0&id=6323cace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323cace",
  null
  
)

export default component.exports